import {
    Autocomplete,
    AutocompleteProps,
    Box,
    CircularProgress,
    FormControl,
    FormHelperText,
    TextField,
} from '@mui/material';
import React from 'react';

import { MlSampleMetadata } from 'app/model';

interface DataSourceSelectorProps
    extends Omit<AutocompleteProps<MlSampleMetadata, false, false, false>, 'options' | 'renderInput'> {
    helperText?: string;
    variant?: 'filled' | 'outlined' | 'standard';
    size?: 'medium' | 'small';
    samples: MlSampleMetadata[];
    loading?: boolean;
    error?: boolean;
}

export const DatasourceSelector: React.FunctionComponent<DataSourceSelectorProps> = ({
    helperText,
    variant = 'outlined',
    size = 'small',
    sx,
    className,
    samples,
    loading,
    value,
    error,
    ...rest
}) => {
    return (
        <FormControl variant={variant} size={size} sx={sx} className={className}>
            <Autocomplete<MlSampleMetadata, false, false, false>
                options={samples}
                getOptionLabel={(option: MlSampleMetadata) => option.name}
                value={value}
                loading={loading}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label='Data Source'
                        variant={variant}
                        size={size}
                        placeholder='Full Data Set'
                        error={error}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                                <>
                                    {loading && (
                                        <Box sx={{ display: 'flex', mr: 1 }}>
                                            <CircularProgress size='1rem' />
                                        </Box>
                                    )}
                                    {params.InputProps.startAdornment}
                                </>
                            ),
                        }}
                    />
                )}
                {...rest}
            />
            {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
        </FormControl>
    );
};
